import { render } from "./tabellaPrenotazioni.vue?vue&type=template&id=4ef8bc50&ts=true"
import script from "./tabellaPrenotazioni.vue?vue&type=script&lang=ts"
export * from "./tabellaPrenotazioni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__